(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('privacidad', {
            parent: 'public',
            url: '/privacidade',
            data: {
                pageTitle: 'global.menu.privacidad'
            },
            views: {
                'content@': {
                    template: '<estatica id="privacidad" bd="false"></estatica>'
                }
            }
        });
    }
})();
